
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(2702|3797|4182|9247)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
